// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1VxlU","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1xIvm"};